
import { Component, Prop } from "vue-property-decorator";
import { ProjectView } from "@/views/project-view";
import { IQuery, IQueryDefault, ObjectHelper, QuickHelper } from "@root/core";
import { throttle } from "@root/core/decorators/throttle";
import { uiMetaRuleMatch, uiMetaRuleUnmatch } from "@root/core/tags/ui-meta";

@Component
export default class extends ProjectView {
    @Prop({ type: String, required: false })
    id?: string;

    /// define
    quick = this.quicks().User;

    // hold the data / loading / error
    query: IQuery = IQueryDefault();

    /// root modal id
    get modalId() {
        return this.id ?? this.$route.params.id;
    }

    get serverR() {
        return QuickHelper.serverR(this.quick, this.modalId);
    }

    get row() {
        return this.query?.data?.results?.[0];
    }

    /// private helpers
    get QuickHelper() {
        return QuickHelper;
    }
    get ObjectHelper() {
        return ObjectHelper;
    }
    get uiMetaRuleMatch() {
        return uiMetaRuleMatch;
    }
    get uiMetaRuleUnmatch() {
        return uiMetaRuleUnmatch;
    }

    @throttle(1000)
    async doEnableChanged($event) {
        try {
            await this.$server.U(this.quick.path as any, {
                data: { enable: !this.row.enable },
                where: { id: this.row.id },
            });
            this.query.reload?.();
        } catch (e) {
            if ((e as any)?.handled) return;
        }
    }

    doResetPassword() {}
    onDeleteSuccess() {
        this.$router.push(this.quick.path);
    }
}
